import { render, staticRenderFns } from "./HomeMainContent.vue?vue&type=template&id=06344c34&"
import script from "./HomeMainContent.vue?vue&type=script&lang=js&"
export * from "./HomeMainContent.vue?vue&type=script&lang=js&"
import style0 from "./HomeMainContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports